import { SelectButtonWithChip } from "../button/Buttons.js";
import "../button/EditButton.js";
import { withDropdown } from "./DropdownHoc.js";
const DropdownButtonWithChip = withDropdown(SelectButtonWithChip);
export {
  DropdownButtonWithChip
};
//# sourceMappingURL=DropdownButtons.js.map
